// @flow

import styled, { css, keyframes } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontNormal } from "@fdr/static-ui/Typography";

export const Container = styled.svg.attrs({
  "data-qa-label": "halfCircleValue"
})`
  width: ${({ width }) => width}px;
`;

export const HalfCircle = styled.path`
  stroke: ${buildColor("grey", "200")};
`;

const calculatedDashoffset = (percent: number) => 142 - (percent * 142) / 100;

const animateStrokeDashoffset = (percent: number) => keyframes`
  from {
    stroke-dashoffset: 142;
  }
  
  to {
    stroke-dashoffset: ${calculatedDashoffset(percent)};
  }
`;

export const PercentageHalfCircle = styled.path`
  stroke: ${({ barColor }) => barColor};
  stroke-dasharray: 142;
  ${({ hasStrokeAnimation, percent }) =>
    hasStrokeAnimation
      ? css`
          animation: ${animateStrokeDashoffset(percent)} 0.6s linear forwards;
        `
      : css`
          stroke-dashoffset: ${calculatedDashoffset(percent)};
        `}
`;

export const PercentageText = styled.text.attrs({
  "data-qa-label": "halfCircleText"
})`
  font-family: ${fontNormal};
  fill: ${({ textColor }) => textColor};
  text-anchor: middle;
  alignment-baseline: auto;
  font-size: ${({ fontSize }) => fontSize}px;
  transform: translateY(-1px);
`;
